import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltRecorderPlayerAudioTogglePauseWireframe from './VeltRecorderPlayerAudioTogglePauseWireframe/VeltRecorderPlayerAudioTogglePauseWireframe';
import VeltRecorderPlayerAudioTogglePlayWireframe from './VeltRecorderPlayerAudioTogglePlayWireframe/VeltRecorderPlayerAudioTogglePlayWireframe';
var VeltRecorderPlayerAudioToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerAudioToggleWireframe.Play = VeltRecorderPlayerAudioTogglePlayWireframe;
VeltRecorderPlayerAudioToggleWireframe.Pause = VeltRecorderPlayerAudioTogglePauseWireframe;
export default VeltRecorderPlayerAudioToggleWireframe;
